import {
  evolutionsChainedIcon,
  evolutionsSelectedIcon,
} from "@/designSystemIcons";
import { BREAKPOINTS } from "@/settings";
import clsx from "clsx";
import { useMediaQuery } from "usehooks-ts";

type Props = {
  evoCombinationType: "chained" | "only-selected";
  setEvoCombinationType: (type: "chained" | "only-selected") => void;
};

export const ChainedOrStandAlone = ({
  evoCombinationType,
  setEvoCombinationType,
}: Props) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  return (
    <div className="flex flex-row my-auto text-white text-xs mobile:text-sm">
      <button
        className={clsx(
          isMobile
            ? "w-20 h-9 touch-device:px-3 rounded-l-md border-[1.5px] flex flex-col items-center justify-center gap-x-1 touch-device:gap-x-2"
            : "px-2 h-7 touch-device:px-3 py-1 rounded-l-lg border-[1.5px] flex flex-row items-center justify-center gap-x-1 touch-device:gap-x-2 touch-device:w-36",
          evoCombinationType === "chained"
            ? "border-evolution-stroke bg-evolution-active"
            : "border-transparent bg-evolution-primary hover:bg-evolution-hover",
        )}
        onClick={() => setEvoCombinationType("chained")}
      >
        <span
          className={clsx(
            "whitespace-nowrap",
            isMobile && "text-sm text-evolution-secondary",
          )}
        >
          Chained
        </span>
        <div className="text-evolution-secondary">{evolutionsChainedIcon}</div>
      </button>

      <button
        className={clsx(
          isMobile
            ? "w-20 h-9 touch-device:px-3 rounded-r-md border-[1.5px] flex flex-col items-center justify-center gap-x-1 touch-device:gap-x-2"
            : "px-2 touch-device:px-3 rounded-r-lg border-[1.5px] flex flex-row items-center justify-center gap-x-1 touch-device:gap-x-2 touch-device:w-36",
          evoCombinationType === "only-selected"
            ? "border-evolution-stroke bg-evolution-active"
            : "border-transparent bg-evolution-primary hover:bg-evolution-hover",
        )}
        onClick={() => setEvoCombinationType("only-selected")}
      >
        <span
          className={clsx(
            "whitespace-nowrap",
            isMobile ? "text-sm text-evolution-secondary" : "",
          )}
        >
          Selected
        </span>
        <div className="text-evolution-secondary">{evolutionsSelectedIcon}</div>
      </button>
    </div>
  );
};
